import Account from './Account'
import {
  AccountHero,
  AccountMobile,
  AccountView,
  AccountWrapper,
} from './Account.styled'
import AccountButtonsView from './AccountButtons'
import AccountContent from './AccountContent'
import AccountDeals from './AccountDeals'
import AccountLoyalty from './AccountLoyalty'
import AccountSlider from './AccountSlider'

export {
  AccountButtonsView,
  AccountContent,
  AccountDeals,
  AccountHero,
  AccountLoyalty,
  AccountMobile,
  AccountSlider,
  AccountView,
  AccountWrapper,
}
export default Account
